// src/pages/ExternalTrigger.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const ExternalTrigger = () => {
  const [filters, setFilters] = useState({
    fromMonth: "",
    fromYear: new Date().getFullYear(),
    toMonth: "",
    toYear: new Date().getFullYear(),
    location: "",
    frequency: "",
  });

  const [locations, setLocations] = useState([]);
  const [frequencies, setFrequencies] = useState([]);
  const [actionables, setActionables] = useState([]);
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState(localStorage.getItem("username") || "");

useEffect(() => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    setUsername("");
    return;
  }

  axios
    .get("/api/users/me/", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      setUsername(res.data.username);
      localStorage.setItem("username", res.data.username);
    })
    .catch((err) => console.error("Failed to load username:", err));
}, []);

  // Load dropdown filters
  useEffect(() => {
    axios
      .get("/api/actionables/filters/")
      .then((res) => {
        setLocations(res.data.locations || []);
        setFrequencies(res.data.frequencies || []);
      })
      .catch((err) => console.error(err));
  }, []);

  const fetchExternalTriggers = async () => {
    if (!username) return;

    setLoading(true);
    try {
      const payload = {
        username,
        type: "ISO External Trigger",
        fromMonth: filters.fromMonth,
        fromYear: filters.fromYear,
        toMonth: filters.toMonth,
        toYear: filters.toYear,
        location: filters.location,
        frequency: filters.frequency,
      };

      const token = localStorage.getItem("accessToken");

      const res = await axios.post("/api/actionables/external-trigger/", payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      setActionables(res.data.actionables || []);
    } catch (e) {
      console.error("Error loading external triggers:", e);
      setActionables([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (username) fetchExternalTriggers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  // helper to build detail link for master vs trans rows
  const buildDetailHref = (a) => {
    // prefer uat_id if present, then id, then actionable_number as fallback
    const idOrUat = a.uat_id || a.id || a.master_id || a.actionable_number;
    if (a.type === "ISO External Trigger") {
      // master-detail route (external triggers)
      return `/actionable-master/${encodeURIComponent(idOrUat)}`;
    } else {
      // trans-detail route (system triggers / completed entries)
      return `/actionable/${encodeURIComponent(idOrUat)}`;
    }
  };

  return (
    <div className="container">
      <div className="header-row">
        <h1 className="header">ISO External Trigger Register</h1>
        <button className="back-button" onClick={() => window.location.href = "/dashboard"}>
          ⬅ Back to Dashboard
        </button>
      </div>

      <div style={{ marginBottom: 12 }}>
        <strong>User:</strong>{" "}
        <span style={{ background: "#eef2ff", padding: "4px 8px", borderRadius: 6 }}>
          {username || "Not signed in"}
        </span>
      </div>

      {/* Filters Section */}
      <div className="filters">
        {/* From Month */}
        <div className="filter-item">
          <label>From Month</label>
          <select name="fromMonth" value={filters.fromMonth} onChange={handleFilterChange}>
            <option value="">Select</option>
            {monthNames.map((m, i) => (
              <option key={i} value={i + 1}>{m}</option>
            ))}
          </select>
        </div>

        {/* From Year */}
        <div className="filter-item">
          <label>From Year</label>
          <input
            type="number"
            name="fromYear"
            value={filters.fromYear}
            onChange={handleFilterChange}
          />
        </div>

        {/* To Month */}
        <div className="filter-item">
          <label>To Month</label>
          <select name="toMonth" value={filters.toMonth} onChange={handleFilterChange}>
            <option value="">Select</option>
            {monthNames.map((m, i) => (
              <option key={i} value={i + 1}>{m}</option>
            ))}
          </select>
        </div>

        {/* To Year */}
        <div className="filter-item">
          <label>To Year</label>
          <input
            type="number"
            name="toYear"
            value={filters.toYear}
            onChange={handleFilterChange}
          />
        </div>

        {/* Location */}
        <div className="filter-item">
          <label>Location</label>
          <select name="location" value={filters.location} onChange={handleFilterChange}>
            <option value="">All</option>
            {locations.map((l) => (
              <option key={l} value={l}>{l}</option>
            ))}
          </select>
        </div>

        {/* Frequency */}
        <div className="filter-item">
          <label>Frequency</label>
          <select name="frequency" value={filters.frequency} onChange={handleFilterChange}>
            <option value="">All</option>
            {frequencies.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <button className="apply-button" onClick={fetchExternalTriggers}>Apply Filters</button>
        </div>
      </div>

      {/* Data Table */}
      <div className="card">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Actionable Number</th>
                <th>Actionable Name</th>
                <th>Location</th>
                <th>Type</th>
                <th>Category</th>
                <th>Description</th>
                <th>Owner</th>
                <th>Policy / Document</th>
              </tr>
            </thead>
            <tbody>
              {actionables.map((a, i) => {
                const href = buildDetailHref(a);
                return (
                  <tr key={i}>
                    <td>
                    <a href={href}>{a.actionable_number || "—"}</a>
                    </td>
                    <td>{a.actionable_name || "—"}</td>
                    <td>{a.location || "—"}</td>
                    <td>{a.type || "—"}</td>
                    <td>{a.category || "—"}</td>

                    <td>{a.actionable_description || "—"}</td>
                    <td>{a.username || "—"}</td>
                    <td>{a.policy_or_document_name || "—"}</td>
                  </tr>
                );
              })}

              {actionables.length === 0 && !loading && (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: 20 }}>
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* CSS */}
      <style>{`
        .container {
          padding: 20px;
          font-family: Arial, sans-serif;
          background-color: #f5f5f5;
        }

        .header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #333;
        }

        .back-button {
          background-color: #6b7280;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
        }

        .back-button:hover {
          background-color: #4b5563;
        }

        .filters {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          background: #fff;
          padding: 15px;
          border-radius: 15px;
          margin-bottom: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .filter-item {
          display: flex;
          flex-direction: column;
          min-width: 150px;
        }

        .filter-item label {
          margin-bottom: 5px;
          font-weight: 500;
          color: #555;
        }

        .filter-item select,
        .filter-item input {
          padding: 6px 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .apply-button {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          margin-top: auto;
        }

        .apply-button:hover {
          background-color: #0056b3;
        }

        .card {
          background: #fff;
          padding: 20px;
          border-radius: 15px;
          margin-bottom: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        table th, table td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }

        table th {
          background: linear-gradient(135deg, #102a71, #2053c3);
          color: white;
          font-weight: 700;
        }

        table tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        a { color: #2053c3; text-decoration: none; font-weight: 700; }
        a:hover { color: #102a71; }
      `}</style>
    </div>
  );
};

export default ExternalTrigger;
